export default {
  title: 'リブラの見た夢',
  name: {
    libra: 'リブラ',
    amili: 'アミリ',
    kajitsu: 'カジツ',
    flog: 'カエル',
    fallFlog: '秋カエル',
    torrent: 'トレント',
    bat: 'コウモリ',
    snake: 'ヘビ',
    signal: '信号',
    penguin: 'ペンギン',
    pinkPenguin: 'ピンクペンギン',
    anton: 'アントン先生',
    minePenguin: '炭鉱ペンギン',
    doctorPenguin: '医者ペンギン',
    pumpkin: 'カボチャ',
    pig: 'ぶた',
    ghost: '幽霊',
    patient: '患者',
    beetle: 'カブトムシ',
    stagBeetle: 'クワガタ',
    hercules: 'ヘラクレス',
    ladybird: 'テントウムシ',
    grey1: 'グレイ',
    grey2: 'グレイ'
  },
  place: {
    home: '部屋',
    forest1: '森1',
    forest2: '森2',
    forest3: '森3',
    forest4: '森4',
    forest5: '森5',
    stomach: '胃',
    cave1: '洞窟1',
    cave2: '洞窟2',
    cave3: '洞窟3',
    base: '基地',
    ice1: '氷1',
    ice2: '氷2',
    ice3: '氷3',
    ice4: '氷4',
    dark: '暗闇',
    crossing: '事故',
    heart: '心臓',
    fall1: '秋1',
    fall2: '秋2',
    coalmine1: '炭鉱1',
    coalmine2: '炭鉱2',
    coalmine3: '炭鉱3',
    coalmine4: '宇宙港',
    cosmos: '宇宙',
    hospital1: '病院1',
    hospital1night: '病院1（裏）',
    hospital2: '病院2',
    hospital2night: '病院2（裏）',
    mansion1: '豪邸1',
    mansion2: '豪邸2',
    mansion3: '豪邸3',
    cemetery: '墓',
    brain: '脳'
  },
  item: {
    apple: 'リンゴ',
    grass: '草',
    lily: '百合',
    cosmos: 'コスモス',
    dandelion: 'タンポポ',
    kinoko: 'キノコ',
    clover3: 'クローバー',
    clover4: '四葉のクローバー',
    gardenia: 'クチナシ',
    moss: '光る苔',
    strawDoll: '藁人形',
    stone: '石',
    rock: '岩',
    sapphire: 'サファイア',
    emerald: 'エメラルド',
    amethyst: 'アメジスト',
    ruby: 'ルビー',
    crystal1: '岩の塊',
    crystal2: '岩の塊',
    fish: 'サカナ',
    uminoke: 'ウミノケ',
    unagi: 'うなぎ',
    ice: '氷',
    unadon: 'うな重',
    antonLetter: 'アントンの手紙',
    pityLetter: '時音の手紙',
    bike1: 'バイク',
    bike2: 'バイク',
    bike3: 'バイク',
    matsutake: '松茸',
    coinGold: '金貨',
    coinSilver: '銀貨',
    audioSystem: 'CDコンポ',
    bear: 'くま',
    book1: '本',
    book2: '本',
    book3: '本',
    candol1: 'ロウソク',
    candol2: 'ロウソク',
    chest: 'たんす',
    coffin: '棺桶',
    cookies: 'クッキー',
    curry: 'カレー',
    steak: 'ステーキ',
    stirFry: '野菜炒め',
    omurice: 'オムライス',
    lunchbox: 'お弁当',
    wine: 'ワイン',
    medicine1: '薬品',
    medicine2: '薬品',
    elixir: '不老不死の薬',
    cuttingBoard: 'まな板',
    emblem: 'エンブレム',
    guitar1: 'ギター',
    guitar2: 'ギター',
    gun: '拳銃',
    rifle: 'ライフル銃',
    revolver: 'リボルバー銃',
    kitchen: 'キッチン',
    knife: '包丁',
    lamp: 'ランプ',
    libra: '天秤',
    logo: 'ロゴ',
    pedestal: '台',
    pot: '鉢植え',
    rack: '台',
    scalpel: 'メス',
    skul: 'ドクロ',
    sofa: 'ソファ',
    text: '書類',
    tissue: 'ティッシュ',
    tissueEmpty: 'ティッシュの空箱',
    trash: 'ティッシュのごみ',
    trashCan1: 'ごみ箱',
    trashCan2: 'ごみ箱',
    tablemat1: 'テーブルマット',
    tablemat2: 'テーブルマット',
    tv: 'テレビ',
    star: '星',
    vendingMachine: '自動販売機',
    coke: 'コーラ',
    tea: 'お茶',
    art0: '『リブラの見た夢』',
    art1: '『オレンジ』',
    art2: '『1203』',
    art3: '『ジェミー』',
    art4: '『Night Blue』',
    art5: '『孤独』',
    art6: '『ハッピーエンド』',
    art7: '『日没』',
    art8: '『ドクターリブラ』',
    art9: '『枯れた果実』',
    art10: '『とあるところに』',
    art11: '『Wraith』',
    art12: '『宇宙戦争』',
    art13: '『宇宙戦争』',
    art14: '『宇宙戦争』',
    art15: '『恋』',
    art16: '『頑張る炭鉱夫』',
    art17: '『第二次宇宙戦争』',
    art18: '『うたわれない王国』',
    art19: '『魔女たちの工房』',
    art20: '『マッドパンプキン』',
    art21: '『リリア』',
    art22: '『深海』',
    raptor1: '化石（頭）',
    raptor2: '化石（胴）',
    raptor3: '化石（右手）',
    raptor4: '化石（左手）',
    raptor5: '化石（右足）',
    raptor6: '化石（左足）',
    raptor7: '化石（尻尾）',
    raptor: '恐竜の化石'
  },
  quest: {
    torrentFlog: {
      title: '生きることに必死な二人',
      desc: 'トレントはカエルに見せると約束したヘラクレスという虫を無くしてしまった。'
    },
    clover: {
      title: '恋人はクローバー',
      desc: 'カエルは四つ葉のクローバーに生まれ変わった恋人を探している。'
    },
    snakeFlog: {
      title: 'ヘビとカエルの天秤',
      desc: 'ヘビは宝石と引き換えにリンゴをくれるらしい。'
    },
    curse: {
      title: '呪いのかけ方',
      desc: 'コウモリたちは「呪い」が実在するかについて賭けをしている。'
    },
    eel: {
      title: 'ウミノケ',
      desc: '漁師が釣り上げてしまったウミノケという妖怪は、アントン先生が供養してくれるらしい。'
    },
    pityPenguin: {
      title: '気の毒な男',
      desc: '女に騙された気の毒なペンギンは、その事実を受け入れられずに待ち続けている。'
    },
    liveForEveryone: {
      title: '人のために生きるペンギン',
      desc: '人のために生きるペンギンは、「人のため」とは何なのか、分からなくなってしまった。'
    },
    matsutake: {
      title: '夢の高級キノコ',
      desc: '炭鉱夫は一度でいいから松茸を食べてみたい。'
    },
    painter: {
      title: '炭坑の絵描き',
      desc: '売れない絵描きは、亡き母についた嘘を現実にするために絵を売りたい。'
    },
    appreciation: {
      title: 'お屋敷の子ども',
      desc: 'お屋敷の子どもは、頑張っている炭鉱夫にお礼がしたくて絵を描いた。'
    },
    beauty: {
      title: '不老不死の薬',
      desc: 'カボチャの婦人は、自身の美貌を永遠のものとするべく、不老不死の薬を探している。'
    },
    bogusDoctor: {
      title: '犠牲の上の英雄',
      desc: '病院の医者は独学で医者になったが、過去の失敗で命を落とした患者たちのことで苦悩している。'
    },
    forever: {
      title: 'ずっと一緒に居て下さい',
      desc: '病死してしまった女は、一緒に逝くはずだった夫を待っている。'
    },
    raptor: {
      title: '太古のロマン',
      desc: '豪邸の男は、最近恐竜映画を観て恐竜にはまっている。'
    },
    photosynthesis: {
      title: '光合成の味',
      desc: '宇宙人グレイは、研究のため地球の料理を食べたがっている。'
    }
  },
  ui: {
    ok: 'OK',
    cancel: 'キャンセル',
    delete: '削除',
    newGame: 'はじめから',
    continue: 'つづきから',
    location: '場所',
    client: '依頼主',
    questStart: '『#{title}』を開始',
    questComplete: '『#{title}』を完了',
    pickup: '『#{name}』を拾得',
    eat: '『#{name}』を食べた',
    hpRecover: 'HPが#{value}回復した',
    weightOver: '荷物が重すぎてこれ以上持てません',
    cantPutItem: 'ここには置けません',
    saved: 'セーブしました',
    nothingHappened: '何も起きなかった',
    trash: 'ゴミをゴミ箱に捨てた（えらい！）',
    vendingMachine: 'お買い上げありがとうございます',
    revive: '奇跡が起きた',
    raptor: '恐竜の化石が完成した！',
    status: 'ステータス',
    bag: 'かばん',
    quest: 'クエスト',
    map: 'マップ',
    system: 'システム',
    save: 'セーブ',
    config: '設定',
    tips: 'Tips',
    unregistered: '未登録',
    weight: '重さ',
    playTime: 'プレイ時間',
    charmOfHeart: '心の魅力',
    charmOfBody: '体の魅力',
    sumOfCharm: '魅力合計',
    bgmVolume: 'BGM音量',
    seVolume: 'SE音量',
    normalSave: '保存',
    overwriteSave: '上書き保存',
    registerPlace: '現在地を登録',
    moveToRegisteredPlace: '登録した場所へ移動',
    redecorate: '模様替えモード'
  },
  tips: {
    amili: {
      title: 'アミリ',
      desc: 'あなたの恋人のアミリはリンゴを欲しがっています。世界を探索してリンゴを持ち帰りましょう。'
    },
    people: {
      title: '住人',
      desc: 'フィールドには、会話ができる生き物がいます。彼らの頼みごとを聞くとリンゴがもらえます。'
    },
    hp: {
      title: '体力',
      desc: '画面に表示されているハートはあなたの体力です。生き物の攻撃を受けて無くなると、自宅へ強制移動します。'
    },
    charm: {
      title: '魅力',
      desc: '魅力は、恋人のアミリと散歩したり寝たりすると上昇します。魅力が上がると、この世界のより深くへ進むことができます。'
    },
    weight: {
      title: 'アイテムの重さ',
      desc: 'かばんに入るアイテムの重さには上限があります。リンゴは非常に重たいので、早めにアミリに渡しに帰りましょう。'
    },
    use: {
      title: 'アイテムの使用',
      desc: '使用できるアイテムをつかむと、かばんの下部にアイコンが表示されます。アイコンにドロップすることでアイテムを使用できます。'
    },
    dispose: {
      title: 'アイテムの破棄',
      desc: '取得したアイテムはかばんからフィールドにドロップすることで捨てられます。その後マップ移動をするとアイテムは消滅します。'
    },
    store: {
      title: 'アイテムの保管',
      desc: '自宅に置いたアイテムは、マップを移動しても消滅しません。'
    },
    gun: {
      title: '銃',
      desc: '銃を手に入れると、フィールドで使うことができます。アイテムの破壊、生き物の殺害ができます。'
    },
    murder: {
      title: '殺害',
      desc: '会話のできる住人を殺害すると、二度と復活しません。関連するイベントのクリアが不能になります。'
    },
    screenshot: {
      title: 'スクリーンショット',
      desc: 'ゲームのスクリーンショットはF12キーで撮ることができます。'
    }
  },
  tutorial: {
    gunPc: '- 銃 -\n\n銃を手に入れました。\n右クリックを押すと使うことができます。',
    gunSp: '- 銃 -\n\n銃を手に入れました。\n画面右下のボタンを押すと使うことができます。',
    weight: '- 荷物の制限 -\n\n持ち運べる荷物の重さに注意しましょう。\n特にリンゴは非常に重たいので、頻繁に自宅に持ち帰りましょう。',
    home: '- 自宅 -\n\n自宅では、恋人のアミリにリンゴを渡したり、アイテムを保管することができます。',
    amili: '- アミリ -\n\nアミリは、あなたが持ち帰ったものに反応をしたり、設置した家具を使ったりします。\nあなたとアミリの暮らす部屋を充実させていきましょう。',
    map: '- 瞬間移動 -\n\n画面右下の地図のアイコンで現在地を保存すると、別の場所からその場所へ瞬時に移動することができます。\n再度訪れたい場所は忘れずに保存しましょう。',
    quest: '- クエスト -\n\nこの世界にはあなたの助けを必要とする住人がいるようです。\n彼らの悩みに応えることでリンゴをもらえるかもしれません。',
    kill: '- 殺害 -\n\n友好的な住人を攻撃しました。\n殺害してしまうと復活しませんので注意してください。'
  },
  events: {
    block: {
      common: 'この先へはまだ行けません',
      status: '魅力合計が#{status}必要です'
    },
    libra: {
      exclamation: '！',
      question: '？',
      silence: '………。'
    },
    gameOver: {
      amili1: ['リブラ、目さめた？', 'もう怖くないよ'],
      amili2: ['しばらくこうしてよっか']
    },
    forest2Kajitsu: {
      greet: [
        'はじめまして。',
        '私はカジツと申します。',
        '私からこのゲームの基本操作について簡単に説明させていただきます。'
      ],
      walk: {
        pc: [
          '移動はマップ上を左クリック、またはWASDで行います。',
          'まずは私のところまで歩いて来て下さい。'
        ],
        sp: [
          '移動は画面左下のコントローラーで行います。',
          'まずは私のところまで歩いて来て下さい。'
        ]
      },
      talk1: [
        '大丈夫ですね。',
        'では次に私に話しかけてみて下さい。'
      ],
      talk2: {
        pc: [
          '私を左クリックすれば話しかけられます。'
        ],
        sp: [
          '右下のボタンか私をタップすることで話しかけられます。'
        ]
      },
      apple1: [
        '大丈夫ですね。',
        'ではあちらを見て下さい。'
      ],
      apple2: {
        pc: [
          'あそこに落ちているリンゴを拾ってみて下さい。',
          '近付いてからリンゴを左クリックし続けると掴みます。',
          'するとかばんウィンドウが開くので、そこへドロップすると拾う事ができます。',
          '拾ったら私のところへ戻って来て下さい。'
        ],
        sp: [
          'あそこに落ちているリンゴを拾ってみて下さい。',
          '近付いてから、リンゴまたは右下のボタンを押し続けると掴みます。',
          'するとかばんウィンドウが開くので、そこへドロップすると拾う事ができます。',
          '拾ったら私のところへ戻って来て下さい。'
        ]
      },
      completed: [
        '拾えたようですね。',
        '基本的な操作はこんなところです。',
        'ところで、',
        '今日のあなたは、恋人へリンゴを持って帰るためにこの森へ来ましたね。',
        'あなたの部屋は森を抜けて北へ進んだ先にあります。',
        'さあ、彼女が待っていますよ。',
        '私はこれで失礼します。'
      ]
    },
    home: {
      welcomeback: 'おかえり、リブラ！',
      goodmorning: 'おはよう、リブラ。',
      sleeping1: ['ふぁ〜。', 'ごめん、寝ちゃってた。'],
      sleeping2: ['わ！', 'リブラ帰ってたんだ。びっくりした。'],
      cookie: ['みてみて、リブラにクッキー焼いたんだ。', 'どうぞ♪'],
      lunchbox: ['みてみて、リブラにお弁当作ったよ。', 'どうぞ♪'],
      cooking: ['あ、ご飯できてるよ。', '召し上がれ♪'],
      giveApple: ['リンゴを渡す', 'なんでもない'],
      followMe: 'ついて来て',
      letsGo: '行こっか。',
      finishFollowing: '楽しかったね。',
      noApple: 'ないじゃん',
      iloveyou: 'リブラ、大好き！',
      gaveApple1: ['ありがとう！', '今日はどうしたい？'],
      gaveApple2: ['ありがとう！', '次はどうしたい？'],
      reward: ['散歩がしたい', '一緒に寝たい'],
      sleepTwice: ['また！？', 'うん、…いいよ。'],
      requestApple: {
        a: ['リブラ、またお腹が減っちゃった。', 'またリンゴ持ってきて！'],
        b: ['ん～', 'またリンゴ食べたいなぁ', 'リブラ、持ってきてくれるよね？']
      },
      lvup: {
        heart: '心の魅力が上がった',
        body: '体の魅力が上がった',
        newArea: '新しいエリアが解放された'
      }
    },
    itemReactions: {
      grass: ['お部屋に草なんか生やして、何かおかしなことでもあった？'],
      lily: ['あ、部屋に百合の花飾ったんだ～？', 'えへへ。'],
      cosmos: [
        'コスモス飾ったんだね。',
        'コスモスの花言葉は「乙女の純真」だよ。',
        'ちなみにピンクのコスモスだと、「乙女の純潔」らしいよ。',
        '…私たちには合わないね。'
      ],
      dandelion: ['たんぽぽ持って帰って来たの？', 'リブラかわいいね笑'],
      kinoko: ['キノコ採ってきたの？', '食べられるやつかな？'],
      clover3: ['クローバーだ。かわいいね。'],
      clover4: ['四つ葉のクローバー見つけたんだ！？', 'えへへ、これで幸せになれるね！', '…リブラ、', '私、リブラと一緒に居られて本当に幸せだよ。'],
      gardenia: ['いい香りがする。', 'あ、クチナシの香りだね。'],
      strawDoll: ['リブラ、その人形…、', 'なんだか嫌な感じがする…。', 'どこかに捨ててきてよ。'],
      stoneRock: ['いつも色々持って帰ってくるけど、石はさすがにいらないんじゃない…？'],
      gem: ['宝石見つけたんだ！', '綺麗だね。'],
      gemAll: ['宝石いっぱい～。'],
      crystal: ['その大きな岩の塊何！？', 'あ、もしかして宝石とか化石が埋まってるかも！'],
      raptorParts: ['あ、化石だ！', '化石ってワクワクするよね。', '何の化石かな？'],
      raptor: ['え、すごい！恐竜の化石だ！？', 'めっちゃカッコイイじゃん！'],
      fish: ['魚を獲ってきたんだ。', '今日の晩御飯にすればいいのかな？'],
      unagi: ['うなぎだ！？', 'やった！うな重にしよう！'],
      ice: ['なんで氷なんか置いたの！', '寒いよ！'],
      icePenguin: ['あ、もしかしてペンギンさんのために…？', '………。', '…分かったよ、我慢する！'],
      bike: ['バイク持ってきたんだ…？', '…なんだか懐かしい。'],
      bikeAll: ['バイク沢山集めたね～。'],
      matsutake: ['ん～、', 'なんだかすっごく美味しそうな香りがする！'],
      coin: ['わぁ～、', 'リブラったらお金持ちだね！'],
      audioSystem: ['CDコンポ置いたんだね！', '何聴こっか？'],
      bear: ['くまのぬいぐるみだ！', 'かわいい！！'],
      bearMany: ['くまさんたくさん～。', '…って置きすぎじゃない？', 'リブラって寂しがり屋さん？'],
      book: ['本なんか集めちゃってどうしたの～？', 'どうせ読まないじゃん！'],
      candol: ['なんでローソク持って帰って来たの？', '…変なことに使わないでね？'],
      chest: ['箪笥だ。', 'うちは整理が必要だね。'],
      coffin: ['えっ、棺桶を持って帰ってきたの！？', 'さすがに引く…。', '中は、もちろん空だよね…？'],
      wine: ['ワイン？', '私を酔わせてどうするつもり？'],
      medicine: ['お薬？', '変なやつじゃないよね？'],
      elixir: ['不老不死の薬…？', 'なんか嘘っぽい。', 'リブラ、私リブラがおばあちゃんになってもずっと好きだよ。'],
      guitar: ['ギターだ。', '私も練習したら弾けるようになるかな。'],
      gun: ['45口径の拳銃を見つけたんだ。', '自動拳銃としては原点にして頂点。完成された銃だよ。'],
      rifle: ['ボルトアクション式のライフルを見つけたんだ。', '機構がシンプルだから精度や信頼性が高いんだよ。'],
      revolver: ['リボルバー銃を見つけたんだ。', 'このタイプは弾づまりのようなトラブルがなくて信頼性が高いんだよ。'],
      kitchen: ['キッチンだ！', 'これでリブラにご飯を作ってあげられるね。', '楽しみにしていてね。'],
      knife: ['包丁は危ないからリブラは触っちゃダメ。', '料理は私に任せてね。'],
      scalpel: ['メス…？', 'リブラ、お医者さんごっこをしたいなら付き合うけど、それはちょっとリアリティが過ぎるよ。'],
      skul: ['ちょっと、リブラ。', '趣味悪い物部屋に置かないでよ…。'],
      sofa: ['ソファ置いたんだ。', 'これでくつろげるね！', 'たくさん使わせてもらうね。'],
      tissue: ['あ、ティッシュ。', '…うん、まあその位置には必要だよね。'],
      trashCan2: ['ごみちゃんと捨ててえらいね。'],
      tv: ['テレビ置いたんだね！', '海外ドラマが観たいな。', 'リブラは何が観たい？'],
      star: ['お星様を取ってくれたんだね。', 'リブラだけだよ、こんな素敵なプレゼントをくれるのは。'],
      tea: ['あ、『うぇ〜い お茶』だ！', 'のどが渇いたときはやっぱこれだよね。'],
      coke: ['コーラだ！', '一緒に飲もうね。'],
      vendingMachine: ['わーい！自動販売機だ！', '小さい頃ね、お部屋に自動販売機があれば、いつでも好きな飲み物を飲めるのにな、って思ってたの。'],
      insect: ['リブラ！部屋に虫を入れたの！？', '私虫嫌い！！'],
      hercules: ['珍しい虫だろうと嫌なものは嫌！', '…でもまあちょっとカッコイイ。'],
      snake: ['リ、リブラ！部屋にヘビがいるんだけど！'],
      flog: ['カエルさん、こんにちは。'],
      fallFlog: ['オレンジのカエルさん、こんにちは。'],
      bat: ['コウモリを飼うの…？', '虫よりはまあマシだけど…。'],
      pig: ['ぶたさんだ〜。', 'あ…、ぶたさんの前で豚肉使った料理作っても大丈夫…？'],
      ghost: ['…リブラ。', '…私見えちゃいけないものが見えてる気がする。'],
      art: ['絵飾ったんだ？', 'いいね！'],
      artMany: ['絵、ずいぶん増えたね。', '集めてるの？'],
      artAll: ['絵がこんなにたくさん！', '美術館みたいだ。', '頑張って集めてきたんだね。'],
      torrent: ['でっかいの連れて来たね…。'],
      penguin: ['ペンギンさんだ～。', '部屋暑くないかな？'],
      pinkPenguin: ['きゃー！！ピンクのペンギンさん！！', 'かっわいいー！！'],
      pumpkin: ['カボチャさん！', '…おいしそう。', 'リブラ、今日はカボチャコロッケにする？', '………。', '…冗談だよ！'],
      grey: ['宇宙人だ！？', '初めて見た…。', 'あ、でも向こうからしたら私たちが宇宙人か。', 'リブラが誘拐してる側だし…。']
    },
    torrentFlog: {
      start1: [
        'あー、困りました…。',
        '実はカブトムシを探しているんですが、見つからなくて。'
      ],
      options1: ['それは困りましたね', 'カブトムシならすぐ見つかりますよ'],
      start2: [
        'ええ、ただのカブトムシではありません。',
        'この地では非常に珍しいヘラクレスという黄金色のカブトムシなのです。',
        'あのカブトムシを探しださなければ私は嘘つきになってしまうのです。'
      ],
      options2: ['嘘つきに？', '何故ですか？'],
      start3: [
        'はい。あれは先週のことでした。',
        '私は友人のカエル殿と話をしていたのです。',
        '「ところでカエル殿、この森には黄金色のカブトムシが住んでいるのですが、ご存知ですかな？」',
        '「…ううむ、トレントさんや、そりゃあとんだ嘘でございますな。そんなものがこの世に居るものですか」',
        '「いえいえ、嘘なんかじゃあ御座いませんよ。ほんとうに居るのです」',
        '「そうんなことを言って私をからかおうったってそうはいきませんよトレントさん。」',
        '「もしほんとうにそのようなカブトムシが居るのでしたらさっそく連れてきてくだあさいよ」',
        '「からかおうなんてつもりはちっとも御座いませんよ。」',
        '「ですが黄金色のものは大変珍しいものでして、そう容易く連れてくるのはかないませんのです」',
        '「そんなら信じるには至りませんな。このままじゃあトレントさんは大ぼら吹きになっちまいますよ？」',
        '「なんとかしてその黄金色のカブトムシを私のところへ持ってきてくだあさい」',
        'そんなわけで私は慌ててヘラクレスを探しているのです。',
        'はあ困りました…。このままでは私は大ぼら吹きになってしまいます…。',
        'そこでお願いなのですが、もしヘラクレスを見かけたら、どうか私の元へ持ってきて頂きたいのです。',
        'お礼はします。どうかお願いします。'
      ],
      started: [
        'ヘラクレスを見かけたら、どうか私の元へ持ってきて頂きたいのです。',
        'お礼はします。どうかお願いします。'
      ],
      found: [
        'おお！ヘラクレスを持ってきて下さったのですね？',
        'ではそのヘラクレスをこのエリアの南に住むカエル殿のところへ持って行ってくれませんか？',
        '私は長い距離を歩くのが苦手でして…。'
      ],
      options3: ['カエルはあなたを騙していました', 'カエルにヘラクレスを届けました'],
      report: [
        'そうですか。',
        '残念なことですが、生きていればあそういう偽りも必要な時があります。',
        'カエル殿も、私も、生きるのに必死なんです。',
        'ですから、カエル殿の行いばかり責めるのは酷だとは思いませんか？'
      ],
      options4: ['あなたの言うとおり仕方ない', '生きる為でも人を騙してはいけない'],
      end1: [
        'そうですか。これで私の疑いは晴れましたね。',
        'どうもありがとうございました。これはお礼です。'
      ],
      end2: [
        'そうですか、どう考えるかは人それぞれですね。',
        'さあ、これはお礼です。この度は大変助かりました。では。'
      ],
      end3: [
        'そうですか。では、そう答えたあなたには正直に白状しましょう。',
        '実は、この度の話は何もかも嘘なのです。',
        '高価なヘラクレスを手に入れるため、私とカエル殿の共謀であなたを騙しました。',
        '本当に申し訳ありません。',
        'ですが、私も生きるのに必死なんです。',
        'お詫びにこれをお受け取り下さい。では。'
      ],
      completed: '皆、生きるのに必死なんです。',
      flog: {
        greeting: 'こんにちはお嬢さん。',
        give1: [
          'こんにちはお嬢さん。',
          'え？トレントさんから預かり物？',
          'やあやあ！それはヘラクレスじゃあありませんか！',
          'さあ、それを早くこちらへ下さいな！'
        ],
        options1: ['ヘラクレスを渡す', '渡さない'],
        give2: ['まあまあそんなこと仰らずに！'],
        log1: 'ヘラクレスを渡した',
        log2: 'ヘラクレスを奪われた',
        give3: [
          'おお、これがヘラクレス…！',
          'こいつを売れば私も食に苦しみやしませんねえ、ケケケ',
          'トレントさんはお人よしだあ。'
        ],
        options2: ['最初から売るつもりで？', 'トレントを騙したの？'],
        give4: [
          'お嬢さん。',
          '私はヘラクレスを手に入れた。トレントさんは疑いを晴らした。',
          'ただそれだけのことじゃあないですか。',
          'なあにもおかしなことはしておりません。',
          'ですがこの話はトレントさんには内緒でお願いしますよ。それじゃあ。'
        ]
      }
    },
    clover: {
      greet: [
        'やあ、地面によく注意して歩いてくれよな。',
        '僕は今四つ葉のクローバーを探しているんだから。'
      ],
      options1: ['誰かにプレゼント？', 'ごめんなさい'],
      start1: [
        'プレゼントなもんか。',
        'いいか、それはもっと大事なものなんだ。',
        '説明するからよく聞いてくれよ。',
        '結構前のことなんだけどさ、僕の恋人のカエルが死んでしまったんだ。',
        'とても悲しんでいたんだけど、ある日彼女が僕の元に戻ってきたんだ。',
        '彼女はテントウムシに生まれ変わっていたんだ。',
        'すごく嬉しかった。',
        'だけど、カエルとテントウムシじゃ付き合っていくのは難しかったのさ。',
        'だから彼女と相談して、もう一度生まれ変わってもらうことになった。',
        'つまり、僕はテントウムシになった彼女を殺したんだ。',
        'とても辛かったけどね。',
        '何度生まれ変わっても必ず君を見つけるよ、って約束したんだ。',
        'しばらく彼女は現れなかったけど、最近やっとまた彼女が戻ってきたんだ。'
      ],
      start2: [
        '彼女はクローバーに生まれ変わったらしい。',
        'それも四つ葉のクローバーさ。',
        'だけど、彼女の僕を呼ぶ声は聞こえるものの、まだ見つけられていないんだ。',
        'だからさ、もし彼女を見つけたら、僕のところへ連れてきてほしいんだ。',
        '摘んでしまって構わない。'
      ],
      options2: ['四つ葉のクローバーを渡す', 'なんでもない'],
      log: ['四つ葉のクローバーを渡した'],
      complete: [
        'ああ、彼女を連れて来てくれたんだね！',
        'うん、間違いない。彼女だ。',
        'ああ、とても綺麗だよ、サリー。',
        '君は次は何に生まれ変わるんだい？',
        'また何度だって君を見つけるよ。',
        'あ、そうだ、これは彼女を見つけてくれたお礼だ。',
        '本当にありがとう。'
      ],
      completed: [
        '彼女を見つけてくれてありがとう。',
        '今度こそカエルに生まれ変わって戻ってきてくれるといいな。'
      ],
      torrent: [
        '「四つ葉のクローバーが幸せ」なんて誰が決めたんでしょうね。',
        'もしもクローバーの葉は4枚なのが普通で、3枚が珍しいとすると、きっと「幸せの三つ葉のクローバー」なんて言われていたでしょう。',
        'ところで、珍しいものというのは、縁起が良いとされるか忌み嫌われるかのどちらかです。',
        'しかし、縁起が良いとされるはずの四つ葉のクローバーも見つけらると必ず引っこ抜かれてしまいます。',
        '「幸せ」とか言っておきながら四つ葉のクローバー当人からすると不幸極まりないのです。',
        '世間から浮いた存在というものは、どのような形であれ最後には淘汰されるようにできているのでしょうか…？'
      ]
    },
    snakeFlog: {
      start: [
        '物の価値というのはさまざまな状況によって変わるが、最終的にその価値を決めるのは他ならぬ自分だ。',
        'この洞窟の岩からは宝石を採取できるんだが、あるときコウモリの野郎がその宝石を持っていたんだ。',
        'だからおれは言った。',
        '「なあコウモリさん、いつも羽虫ばかり食べていて胃が退屈してるんじゃあないかい？」',
        '「どうだ、その口にくわえた宝石をおれにくれてみろ。きっといいものを食わせてやるぜ」',
        'コウモリの野郎は「そりゃあいい。早速捕ってきてくれ。おいらは新鮮な肉が食いてえな」と言った。',
        'だからおれは洞窟の外でカエルを捕まえてきてやったんだ。',
        'するとどうだ。奴はおもしろくなさそうな顔をしやがった。',
        '「やい、ヘビめ。おいらを馬鹿にしてるのか？宝石とカエル一匹じゃあいくらなんでも釣り合わんじゃあないか」',
        '「おいらだって宝石の価値くらい知っているんだぞ」',
        '「この宝石でおいらの仲間たちを腹いっぱいに出来るくらいの価値はあるはずだろう？」',
        'コウモリの野郎はそう抜かしやがった。だからおれは言ってやったさ。',
        '「ああ。確かにお前さんの言うとおり宝石ってのはそれくらいの価値があるなあ」',
        '「でもあんた、その宝石をどうやって金や食べ物に換えるつもりだ？」',
        '「換えられないんじゃあ世間で価値のある宝石ったってお前さんにとってはただの石ころに過ぎないじゃないか」',
        '「ところがこのカエルの肉はどうだ？お前さんじゃあ滅多にありつけないご馳走じゃあないのかい？」',
        '「つまりだ。おれは石ころをご馳走に換えてやろうと言っているんだ」',
        '「それでもおもしろくねえって言うんなら交換は諦めてこのカエルはおれが今から食べるとしよう」',
        'するとコウモリの野郎は慌てて言った。',
        '「わ、分かった！よーく分かったよ！こんな石ころはいくらでもくれてやる。さあ、早くその肉をおいらにくれ」と。',
        'それ以来やつは毎日宝石をくわえてきた。仲間たちも腹いっぱいにさせたいんだとよ。',
        'そいつとその仲間は日に日に体が丸くなっていった。',
        '宝石一つもくわえて飛べなくなるほど太ったころに、おれは奴らを一匹残らず美味しく頂いたさ。',
        'つまりだ。砂漠で喉の渇きで死にかけている奴の前にコップ一杯の水と札束を差し出してみろという話さ。',
        '世間一般の価値がいつも通用するわけじゃあない。',
        'そういうわけで、あんたも宝石を持ってきたらこのリンゴと交換してやるぜ。'
      ],
      started: [
        'そういうわけで、あんたも宝石を持ってきたらこのリンゴと交換してやるぜ。',
        'そうだな、この洞窟で捕れる4色の宝石をそれぞれ2つずつ集めてきてくれ。',
        '宝石は岩の塊を破壊すれば出てくることがある。',
        '岩の塊を破壊するには銃を手に入れて撃つといい。'
      ],
      options: ['宝石を2つづつ渡す', '渡さない'],
      complete1: 'お、持ってきたか。有り難く頂くよ。',
      logs: ['サファイヤを2個あげた', 'エメラルドを2個あげた', 'アメジストを2個あげた', 'ルビーを2個あげた'],
      complete2: 'ほら、約束してたリンゴだ。',
      completed: 'よう。もう用は済んだはずだぜ。'
    },
    strawDoll: {
      start: [
        'なぁあんた、この藁人形見てくれよ。',
        'これ、森で拾って持って帰って来たんだが、',
        '後からやっぱり気味悪いからってんで捨てて来たんだ。',
        'だけどな、次の日起きてみると捨てて来たはずのこれが家にあったんだ。',
        '何回捨ててきても必ずうちへ戻って来るんだ。',
        '気味悪いだろ？'
      ],
      options: ['気味悪いですね', '私が引き取ります'],
      answer1: ['あぁ。'],
      answer2_1: [
        '本当か？それは助かるな。',
        'じゃあ早速持って行ってくれ。'
      ],
      answer2_2: [
        'でも捨てないでくれよ。',
        'また俺のところに戻ってきたらかなわんからな。'
      ],
      received: ['気味悪いよな、藁人形って…。'],
      disposed: [
        'おい姉ちゃん、例の藁人形、また俺のところへ戻って来たぞ。',
        '貰ったんならちゃんと持っていてくれよ…。'
      ]
    },
    curse: {
      // This conversation is attended 2 NPC, so the Array length and order can not be changed.
      start1: [
        '何度でも言うさ。呪いなんてもんこの世には存在しねえ。', // Right bat
        'いいや、ある。賭けたっていい。', // Left bat
        '証明のしようがないんじゃあ賭けすら成立しないじゃないか。' // Right
      ],
      start2: [
        'ん？', // Left
        'なあ、あんた、その持っている人形…、', // Left
        'それは藁人形じゃあないか。', // Left
        'へえ、よく呪いの儀式だかに使うやつか。', // Right
        '丁度良い。その藁人形を使って試してみようじゃないか。', // Left
        'お、おおそうだな。ぜひそれで俺を呪ってみろ。', // Right
        '俺の身に何か起きたらお前の勝ちだ。', // Right
        'なああんた。そういうわけだ。', // Right
        '今から森に行ってその人形で俺に呪いをかけてきてくれ。', // Right
        'やってきたら報告しに来てくれ。そうしたらお礼を出す。' // Left
      ],
      started1: [
        '森の北の方のエリアにリンゴのなる木があるだろ？',
        'そこにいるトレントが詳しいから彼を頼ってくれ。',
        '頼んだぞ。'
      ],
      started2: [
        '…ふん、呪いの人形だなんて馬鹿馬鹿しいな。'
      ],
      executed: [
        'ああ、あんたはこの前の…。',
        '実は儀式のことなんだが、あれはやっぱり中止だ。',
        'どういうわけか、あいつ、突然病を患ってぽっくり逝っちまったんだ。',
        'だから呪いの儀式はしなくていい。',
        'やっぱりあいつの言うとおり呪いなんてもんはないのかもな。',
        'そりゃあ生きてりゃ突然病気になったりもする。',
        'それを全部呪いだ祟りだーなんて得体のしれないものに責任を押し付けてちゃいかんな。'
      ],
      noticeOptions: ['儀式をしてきた', '儀式はしなかった'],
      answer1_1: [
        'そうか、この先どうなるか楽しみだな。',
        'ほら、これはお礼だ。'
      ],
      answer1_2: [
        'そうか…。', // Right
        'ん？どうした？', // Left
        'いいや…。' // Right
      ],
      answer2_1: [
        'なんだ？やらなかったのか。', // Left
        'そうかそうか、やらなかったのか！', // Right
        'まあ、賭けにはならんかったが、とりあえずこれはお礼だ。' // Right
      ],
      answer2_2: [
        'ん？なんでやらなかったのにお礼なんだ？', // Left
        'いや…、まあ細かい事は気にするな。', // Right
        'じゃ、じゃあな嬢さん。' // Right
      ],
      noticedDid1: [
        'どうなるか楽しみだな。', // Left
        '…。' // Right
      ],
      noticedDid2: [
        'ああ、嬢ちゃん、どうやら賭けは俺の負けのようだ。', // Right
        'あれからどうにも体調が悪くて仕方ねえんだ。', // Right
        '病気なんて滅多にしない俺が突然意味も無くこれだ。', // Right
        'さすがに何かあるのかもしれねえな。', // Right
        'ほらな、言った通りだろ。賭けは俺の勝ちさ。' // Left
      ],
      completed: [
        'まあ何にせよ、誰かに呪われない生き方を目指すのが一番ってこったな。'
      ]
    },
    curser: {
      start: [
        '呪いのかけ方ですか？',
        '簡単ですよ。呪いをかけたい相手に「貴方に呪いをかけた」と知らせればよいのです。',
        '呪いの儀式なんてものをやる必要はありません。',
        '信じられませんか？',
        '「病は気から」と言う言葉がありますよね。',
        'これ、ただのことわざではないんです。',
        '3匹のヘビがグルになってある兎に暗示をかけたことがあります。',
        'こんな話です。',
        '兎に最初に会ったヘビは言いました。',
        '「やあ、兎さん。調子はどうだい？」',
        '「これはヘビさん！お陰様で私はとても元気ですよ！」',
        '「そうかい？どうやら顔色が優れないように見えますよ？」',
        '「え？そうですか？」',
        '2匹目に会ったヘビも言いました。',
        '「やあ、兎さん。おや、顔色が悪いね。大丈夫かい？」',
        '「え？そうですかねぇ…？」',
        '最後に3匹目に会ったヘビが聞きました。',
        '「やあ兎さん。調子はどうだい？」',
        '「うーん…。実はちょっと具合が悪いんです…。」',
        '確かに元気だったはずの兎が、他人の言葉だけで「自分は具合が悪い」と錯覚してしまったのです。',
        'このように、暗示というのは案外単純なものなんです。',
        '儀式はせずに相手に「呪いをかけた」とだけ伝えてみてはどうでしょう？',
        'まあ、どうしても実際に呪いの儀式をしたいのであれば、',
        '呪いの人形を持って来てくれればお手伝いしますよ。',
        'おすすめはしませんが。'
      ],
      options: ['呪いの儀式をする', '呪いの儀式はしない'],
      failed: ['おや、呪いの人形がなければ儀式は出来ませんよ？'],
      exec1: [
        '分かりました。',
        'では、始めます。',
        '呪いの人形を貸して下さい。'
      ],
      exec2: [
        '儀式は終わりました…。',
        'では…。'
      ],
      cancel: ['では。'],
      greet: ['調子はどうですか？'],
      options2: ['元気です', '呪いの儀式をしたい']
    },
    eel: {
      start1: [
        'なあニンゲンのお嬢さんや、ワシは今日漁に行って来たんだが、困ったことにウミノケを釣ってしまったんだ。',
        'すまんがこれをアントン先生のところへ持っていって供養してもらってくれないか？'
      ],
      startOptions1: ['ウミノケ？', 'いやです'],
      start2: [
        'ウミノケを知らんか。',
        'あれは数年前のことだ。漁で普段見たことのねえ魚が釣れたんだ。',
        '黒くて蛇みたいなにょろにょろした形で少々気味が悪かったよ。',
        '家に帰って試しに食ってみたんだが、やけに脂が乗っていてそりゃあ美味かった。',
        'あまりに美味いもんで、焼いたり刺身にしたりしてその日のうちに一匹丸々平らげたよ。',
        'しかし、あとからどうにも腹が痛くて吐き気もして仕方なくなったんだ。',
        'まあただの食当たりかとも思ったんだが、',
        '今度は皮膚が青紫色になったり、体が金縛りのようになったり、呼吸がし辛くなったりとそりゃあ酷いことになった。',
        'こりゃあいくらなんでも様子がおかしいってんで慌ててアントン先生という方に相談しに行ったんだ。',
        '事情を話すとアントン先生はこう聞いてきた。',
        '「あんた、その魚はどんな姿をしていました？」',
        '「ええと、蛇のような姿でまっ黒でした」',
        '「あんたなあ、そりゃあきっとウミノケですよ」',
        '「な、なんですかそれは？」',
        '「ウミノケってのは海の妖怪で、魚なんかじゃあないですよ」',
        '「そんなもんを食っちまっては呪われても当然ということです」',
        'ワシは顔が真っ青になりましたよ。',
        '「そ、そんな！ど、どうすれば？」',
        '「まあ慌てなさんな。ちゃんと祓ってやります」',
        'そうしてワシは祓ってもらった後すっかり楽になったんです。',
        'でも、もしまた漁であの妖怪が釣れたらと思いゾッとして聞きました。',
        '「また、ウミノケが釣れたらどうしましょう先生？」',
        '「ああ、そんときは必ずウチへ持ってきなさい。ちゃあんと供養しますからね」',
        'それからというもの、ウミノケを釣ってしまう度に先生のとこへ持って行ってるんだ。',
        'で、最初に言った通り今日もヤツが釣れてしまったんだ。',
        'だから、悪いがお嬢さん、お礼を出すからアントン先生のとこへ持って行ってくれねえか？'
      ],
      startOptions2: ['いいですよ', 'いやです'],
      answer1: ['たのんだぞ。'],
      lost: ['おいおい、ちゃんと持って行ってくれよ。'],
      answer2: ['そうか。'],
      start3: ['悪いがお嬢さん、お礼を出すからアントン先生のとこへ持って行ってくれねえか？'],
      end1: [
        '供養は終わったようだな。御苦労さん。',
        'お礼を持って行ってくれ。じゃあな。'
      ],
      endOptions: ['うな重と手紙を渡す', '手紙のみを渡す'],
      log1: 'アントンの手紙を渡した',
      log2: 'うな重を渡した',
      end2: [
        'アントン先生…。正直驚いたよ…。',
        'まあ、確かにあんな美味いんじゃあ仕方ねえかもな…。',
        'しかし、無知というのは損なもんだなあ。',
        'ワシが無知ゆえに腹を下し、妖怪の話なんぞに騙され、その後も美味いものをずっと食い損ねていただなんてよ。',
        '今は怒りよりも自分の無知を恥じているよ。',
        'とにかく、今回はありがとうな。これを貰ってくれ。じゃあな。'
      ],
      completed1: ['この前は助かったよ。'],
      completed2: ['世の中無知なやつほど損をしていくのかなぁ…。']
    },
    anton: {
      start1: [
        'おや、ニンゲンのお嬢さん。今日はどうしました？'
      ],
      startOptions1: ['ウミノケを渡す', 'なんでもない'],
      giveLog: 'ウミノケを渡した',
      start2: [
        'おや、これはウナギじゃあないですか。',
        'もしかしてこれを譲ってくれるのですか？'
      ],
      startOptions2: ['え、ウミノケでは？', 'ウナギ？？'],
      start3: [
        'えっ？',
        'あっ！ああ、なるほど…あなたはあの方の使いで…',
        'ええと…。',
        '…正直に白状します。',
        '実はこの魚、ウナギと言うとても美味しい魚なんです。',
        '私はこれが大好物でして。',
        'あなたにお使いを頼んだであろう彼には嘘を吐いたんです。',
        'ウミノケなんて妖怪はおりません。',
        'ウナギの血液にはイクシオトキシンという毒がありますからね。',
        '彼が話した症状はまさにその毒によるもので、決して呪いなどではありません。',
        'しかし、ウナギの毒も火に通せばすっかり無害なのです。',
        '彼はきっと刺身で食べてしまったのでしょう。',
        'あの時、私には悪い考えが浮かんでしまいました…。',
        '私は、「それは海ノ怪であるから食べずに持って来い」と嘘を…。',
        '結果として滅多に味わえない至高の魚を彼は私に持って来るようになったのです。',
        'ああ、どうかそんな目で見ないでください。',
        '彼には申し訳ないながら、人を騙してでも食べたい味なのですよ…。',
        'どうか内密にお願いします。'
      ],
      startOptions3: ['代わりに調理したウナギを食べさせて', '正直に謝った方がいい'],
      answer1_1: ['分かりました。'],
      answer1_2: [
        '出来ました。お持ち下さい。',
        'では。'
      ],
      answer2_1: [
        'そうですね。確かにそうするべきです。',
        'ちょっと待っていて下さい。'
      ],
      answer2_2: [
        '出来ました。調理したウナギと、こちらは謝罪の手紙です。',
        'どうかこれを彼に届けてください。'
      ],
      solved: ['では。']
    },
    liveForEveryone: {
      start: [
        '私にはその人の「欲しいもの」や「してほしいこと」が見えます。',
        'ほんとうですよ。',
        'あなたは今リンゴが欲しいのではないですか？',
        '当たっていますね？',
        '天から授かったこの能力で、私は誰かのために生きることを誓っていたのです。',
        'これまで私は、その人の望みが私に叶えられる場合、いつも見返りを求めずに叶えてきました。',
        'いいえ。見返りを求めていないつもりだったのです。',
        '先日、ある旅のお方とすれ違ったのですが、彼は喉が渇いていたらしく飲み物を望んでいたのです。',
        'ですから私はお茶の入った水筒を差し上げたのです。',
        'するとそのお方は水筒のお茶を飲み干し、無言で去って行ってしまったのです。',
        '私はお礼の一言を言わなかった彼に疑問を感じたのです。',
        'そのとき気付いてしまったのです。',
        '私はお礼を見返りにお茶を差し上げていたのではないかと。',
        'そのお方の喉の渇きを潤せたときに私の使命は果たせていたはずなのです。',
        'なのに私の心は無意識にお礼を待っていたのです。',
        'このような心をもって「誰かのため」などという生き方は務まりません。',
        '私は「誰かのため」がどういうものなのか、ここ数日考えていました。',
        '例えば、己の命と引き換えに誰かの命を救ったとしたら、それは「誰かのため」といえるでしょうか？',
        'もしかしたらそれは、死後も残る栄誉という見返りを求めた行動といえるのかもしれません。',
        '「全ての行いは己のためのもの」、今の未熟な私にはどう転んでもその結論に至ってしまうのです。',
        '私はまた一から修行を積み直すつもりです。',
        'ほんとうの「誰かのため」の生き方が何たるかを悟らねばなりません。',
        'ここまで聞いてくださってありがとうございました。',
        'さあ、これはほんのお礼です。'
      ],
      options: ['ありがとう', '見返りのために話を聞いたのではない'],
      answer1: [
        'いいえ、こちらこそありがとう。またどこかでお会いしましょう。では。'
      ],
      answer2: [
        'ふふ。そうですね。ではこれは長話に時間を取らせてしまったお詫びということにしましょう。',
        'それでは、またどこかで。'
      ],
      completed: ['日々、修行あるのみです。']
    },
    pityPenguin: {
      greet: ['何か用ですか？'],
      options: ['手紙とクチナシを渡す', '手紙のみを渡す', 'なんでもない'],
      log1: '時音の手紙を渡した',
      log2: 'クチナシを渡した',
      solve1: [
        'これは…。',
        '僕は、もう彼女とは…会えないんですね…。'
      ],
      reactions: ['怨んでいないんですか？', 'そんな女は忘れましょう'],
      answer1: [
        '怨んでなんていませんよ。',
        '僕は彼女を愛していたんですから。'
      ],
      answer2: [
        '僕は彼女を愛していました。'
      ],
      solve2: [
        '騙す気だったかなんて関係ありません。',
        '持って行かれたお金が惜しいとも思いません。',
        '彼女ともう会えないのがただ悲しいだけです。',
        'でも、そんなことを言っていたって仕方がありませんね…。',
        '少しずつ気持ちを切り替えていくことにします。',
        'この度はありがとうございました。これをお持ち下さい。'
      ],
      solve3: [
        'これは…。',
        'これは、彼女が書いたものではありませんね…？',
        '…。',
        'はあ、僕は何をずっとくよくよしていたんだ…。',
        '友にまでここまで心配させてしまって…。',
        '本当は騙されていた事に心のどこかで気付いていたんだ。',
        'どうしてもそれを認めたくなかっただけなんです。',
        'もう彼女とは…会えないんですね…。',
        'でも、もう大丈夫です。',
        '僕には心配してくれる友人もいますしね。',
        'この度はありがとうございました。これをお持ち下さい。'
      ],
      solved: [
        '僕は、もう大丈夫です。'
      ]
    },
    pityPenguinFriend: {
      start1: [
        '北の穴にはハチという男が住んでいたんだが、',
        'こいつがまあ～、いつまで経っても女に恵まれない奴でな。',
        '天涯孤独と開き直って独り寂しく暮らしてたんだわ。',
        'しかし、数ヶ月前のことなんだが、あいつの元に一人の女が訪れたらしい。',
        'それがたいそう美しい女だったらしく、そんな者が自分などに何の用だと思って用件を聞くと、',
        '「時音と申します。突然で不審とお思いかもしれませんがどうか聞いてください」',
        '「この度用事でこの地を訪れました。そして表であなたをお見かけし、私の心は一目で貴方の虜となりました」',
        'なんて言い出したらしい。',
        '挙句の果てには今すぐめとってくれと家に上がり込もうとしたそうだ。',
        'もちろんそんなうまい話はこの世にないさ。',
        'いくらハチといえど疑ったそうだ。',
        '「そんな口から出まかせで僕を騙そうだなんて気分が良くないなあ」',
        '「きっと家に上げたら夜中に僕が寝た隙に何もかも盗り去ってしまうんだろう？」',
        'そう言うと女は、「そんなつもりはありません！なんなら私の足首と部屋の柱を紐で繋いでくれたって構いません！」',
        'と抜かしたそうだ。',
        'そこまで言うんならとハチはそいつを部屋に上げて本当に紐で足首と柱を繋いだらしい。',
        'すると女はニコニコと嬉しそうにハチを見るばかりで、ハチもすっかり混乱してしまった。',
        'そんなハチだったが、その晩にはちゃっかりその女と夜を共にしたわけだ。',
        'そうなってしまうともう大変さ。',
        '今まで女縁の無かったハチは一晩ですっかりその女にぞっこんだ。',
        '「ほんとうにボクと結婚してくれるのかい？」',
        '「何度でも申し上げます。私はあなたのものです」',
        '相変わらず女はニコニコ嬉しそうな顔だ。',
        '「でも貴女は用事でここに訪れていたんだろう？一度帰ってご家族に挨拶をせねばならんよ」',
        '「分かりました。確かに両親も心配していると思うので、一度挨拶に帰ります」',
        '早速帰る準備を始めた女にハチは札の束を差し出した。',
        '「これは往復の旅の費用と、ご実家への支度金だよ」',
        '女の実家の方に相手が貧しい男と思われてはいけないと考え、支度金はかなり渡したそうだ。',
        '「必ず戻ってきます」',
        'そうして一度実家へ帰っていった女だが、いつまで待てど戻ってくる気配が無い。',
        'ハチは街の外れでずぅっと帰りを待っているが、やっぱり戻ってくるわけはねえ。',
        '最初はちゃんと怪しいと思って疑ってたのに、',
        'たった一晩でこれだ。',
        '男ってのはなんでこうも馬鹿なんだろうな？',
        '「悪い女に騙されたんだ、諦めろ」と誰が声をかけても聞きやしねえ。',
        'なんと、未だにずぅっと待っているんだ、あいつは。',
        '俺はその姿が気の毒でならねえ。何とか諦めさせてやりたいのさ。',
        'そこで思いついたんだ。',
        'あの女のフリをして手紙を出して、結婚はできないとハッキリ伝えれば諦めるんじゃないかってな。',
        'でもただ手紙を出しても疑わしい。',
        'そこでクチナシの花を添えようと思うんだ。',
        'その女が住む地にはクチナシが沢山咲いていると話していたらしいんだ。',
        'それを添えればさすがに信じるだろう。',
        'どうだ、姉ちゃん。ひとつ協力してくれないか？'
      ],
      start2: [
        '森に行ってクチナシを一輪採ってきほしいんだ。',
        'それまでに手紙は用意しておく。'
      ],
      options: ['クチナシを渡す', 'なんでもない'],
      found1: [
        'よし、よくやった。',
        'じゃあこの手紙と一緒に渡してきてくれ。'
      ],
      found2: [
        'ハチはこの北へ抜けた先だ。',
        '手紙とクチナシを渡してきてくれ。'
      ],
      lost: [
        'おいおい、手紙なくさないでくれよ。'
      ],
      solved: ['届けてきてくれたようだな。あんたのおかげで助かったよ。'],
      completed: ['女に騙されるのは恥ずかしい事なんかじゃあないさ。']
    },
    dark: {
      kajitsu1: 'それが懐かしいですか？',
      kajitsu2: ['ここがどこだか思い出しましたか？'],
      kajitsu3: [
        '思い出せませんか…。',
        'あなたがこの世界へ来てから一ヶ月ほどが経ちました。',
        'しかしあなたは何故ここへ来たのかを忘れている。'
      ],
      kajitsu4: ['このままではアミリさんが危ないですよ。'],
      kajitsu5: ['私はこの先で待っています。必ず来てください。']
    },
    crossing: {
      start1: '思い出しましたか？',
      start2: ['そうです。貴方はここで死んだのです。'],
      start3: [
        'ですがこの世界は死後の世界と言うわけではありません。',
        'この世界はアミリさんの心の中です。',
        '一緒に事故に遭ったアミリさんは、現在昏睡状態に陥っています。',
        '貴方は霊体としてアミリさんの心の中に入ってしまったのです。'
      ],
      start4: ['こちらへ来て下さい。']
    },
    heart: {
      start1: ['アミリさんの心臓です。'],
      start2: [
        'アミリさんは生きています。',
        'しかし、ここに貴方が居るばかりにアミリさんは目を覚ませずにいるのです。'
      ],
      start3: [
        'アミリさんが目覚めるためには貴方がここから出ていかなければいけません。',
        'ここを出ると貴方は成仏し、天国へ行きます。',
        'ここから出て行く方法は単純です。',
        'ここから強く出たい、と願うだけです。',
        'しかし、今の貴方にはそれだけの決意がありません。',
        '躊躇いがあります。'
      ],
      start4: [
        'そうですね…、',
        '交差点から北へ向かって下さい。',
        'アミリさんの脳内に辿りつきます。',
        'そこにヒントがあるでしょう。'
      ]
    },
    matsutake: {
      start: [
        'この炭坑の外の森には松茸という高級なキノコが生えているらしい。',
        'しかし見ての通り俺達はこういう身分だ。',
        '高級な食べ物なんて一生食えずに死んでゆくのさ。',
        '俺はここの労働者たちの中でもかなり歳を食っている身だ。',
        'ここでの寿命を考えればもう5年も経てば働けなくなって、捨てられて、そのまま野垂れ死ぬのさ。',
        'あんまりにも惨めだろう？',
        'だがもう絶望することにも飽きたさ。',
        'わめいたってどうにもならん。',
        'なあ姉ちゃん。',
        '一つわがままを言うと俺は死ぬ前に一度でいいから美味いもんを食いたい。',
        '松茸を一つ俺のために採って来てくれないか？',
        'タダでとは言わない。',
        'このリンゴ、さっき見張りからくすねたんだ。',
        '松茸とは釣り合わんだろうが、俺にはこれが限界だ。',
        'どうか俺の最後のわがままを叶えてくれ。'
      ],
      started: ['松茸を1個だ。どうか頼んだぞ。'],
      options: ['松茸を1個渡す', 'キノコを1個渡す', '渡さない'],
      log1: '松茸を1個あげた',
      log2: 'キノコを1個あげた',
      complete1: [
        'おお！これが松茸か！',
        'じゃあさっそくいただこう。',
        '………。',
        'う、美味い！！！',
        '美味いぞ！！！',
        'この香りは…！',
        '貴族になった気分だあああーーー！！！',
        '………。',
        'ふぅ。',
        '高級とはいえたかがキノコだろ、と思っていたが、',
        '予想以上に美味かったぞ。',
        '仲間の一人は、「高級だから美味いと錯覚してるだけで実際大したことない」と言っていたが、',
        'あいつはただの貧乏舌の馬鹿舌だったようだな。',
        'とにかく、こんな美味いものを食えたんだ。もう俺の人生に悔いわないぜ。',
        'ありがとうよ。',
        '約束のお礼だ。'
      ],
      complete2: [
        'おお、これが松茸か。',
        '見た目はごく普通のきのこだな？',
        'まあ食べてみるとしよう。',
        '………。',
        'うーん…、んんん？',
        '美味いは美味いが、それほど驚きはないな。',
        '仲間の一人が、「高級だから美味いと錯覚してるだけで実際大したことない」と言っていたが、',
        'その通りなのかもしれないな。',
        'ああ、せっかく探してきてくれたのにすまんな。',
        'とにかく頼みを聞いてくれてありがとう。',
        '約束のお礼だ。'
      ],
      completed: ['頼みを聞いてくれてありがとうな。もう俺の人生に悔いはないぜ。']
    },
    painter: {
      start: [
        'ご存知の通りここはタコ部屋労働のようなところです。',
        '僕はここへ連れてこられる前、絵描きをしていました。',
        '絵を描くのは好きだったんですが、商売としてはうまくいきませんでした。',
        'もともと家が貧しかったのもあって生活は少し苦しかったんです。',
        '一時期はヤケになって自分の絵をビリビリに破り捨ててしまったことだってありました。',
        'それでも何とか生活を続けてきました。',
        'そんなある日、母親が体調を崩して寝込んでしまいました。',
        'すぐに病院へ連れて行こうとしましたが、母は医療費を気にしてか断りました。',
        '「こんなのは寝ていれば治る。私は大丈夫だから、アンタは仕事続けなさい」と。',
        '確かに病院へ通えるだけのお金はありませんでした。',
        '僕はただの風邪かなんかだと思う事にして、母の言うとおり絵を描き続けました。',
        'しかし、母は日に日にやつれていき、ついには声を出すのもやっとという状態になっていたのです。',
        '僕はただただ不甲斐無いばかりで、いつにも増して必死に絵を描きましたが、やはり売れる事はありません。',
        'やむなく僕は高利貸しから医療費を借りたのです。',
        'そうして母を入院させました。',
        'お金のことを心配する母には「ついに絵が評価されて売れ始めた」と嘘を吐きました。',
        '母は心底嬉しそうな顔をしていました。',
        '………。',
        '…やがて母は亡くなってしまいました。',
        '母が使っていた箪笥を整理しようと開けると、中には沢山の紙片が入っていました。',
        '…僕が昔ヤケになってビリビリに破って捨てたはずの絵でした。',
        '母はいつも言っていました。',
        '「アンタの夢が叶う事が、私の夢だから、諦めずに続けなさい」と。',
        '僕は今も時間を見つけては絵を描き続けています。',
        'でも僕は一生働いてもここから出しては貰えないでしょう。',
        'そこでお願いです。この絵を代わりに売って来て貰えないでしょうか？'
      ],
      talked: ['お願いです。この絵を代わりに売って来て貰えないでしょうか？'],
      options: ['いいですよ', 'いやです'],
      answer1: [
        'ありがとうございます！',
        '秋の森を抜けた先にお屋敷があります。',
        'そこへ持って行ってみて下さい。',
        'では、よろしくお願いします。'
      ],
      answer2: ['…そうですか。'],
      started: [
        '秋の森を抜けた先にお屋敷があります。',
        'そこへ持って行ってみて下さい。'
      ],
      lost: ['ちょっと。ちゃんと持って行って下さいよ。'],
      complete: [
        'え！？僕の絵が売れたんですか！？',
        'やった！！',
        'よかった…。',
        '…ああ、…よかった。',
        '…うう、すみません。',
        '嬉しくて、つい涙が…。',
        'お金はあなたが全額貰って下さい。',
        'この度は本当にありがとうございました。'
      ],
      completed: ['本当にありがとうございました。']
    },
    collector: {
      start: [
        '俺は絵画を集めるのが趣味なんだ。',
        'いい絵があったら俺のところへ持ってきてくれ。',
        '高く買ってやる。'
      ],
      options: ['この絵を買ってほしい', 'なんでもない'],
      solve1: ['見せてみろ。'],
      log: '『恋』を渡した',
      solve2: [
        'ふむ。悪くないな。',
        'よし、買ってやろう。',
        'ほらよ。'
      ],
      solved: ['この前の絵描きによろしく言っておいてくれ。']
    },
    child: {
      start: [
        'ねえ、お姉ちゃん。',
        '森の奥の炭鉱で働いてるおじちゃんたちのこと知ってる？',
        '毎日ずうっと働いてるんだよ。',
        'それでね、僕たちの生活はそのおじちゃんたちのおかげなんだって。',
        'だから僕ね、おじちゃんたちにお礼言いに行こうと思ったんだけど、',
        'ママが行っちゃいけないって言うんだ。',
        'だからねお姉ちゃん、',
        '代わりに「いつもありがとう」って伝えてきてほしいんだ。'
      ],
      options: ['いいよ', 'やだ'],
      answer1: [
        'ほんとに！？',
        'じゃあさ、この絵も持って行ってね！',
        '頑張ってるおじちゃんたちを描いたんだ！',
        '喜んでくれるかなぁ？',
        'じゃ！頼んだよ！'
      ],
      answer2: ['いじわる。'],
      started: ['僕の絵、炭鉱のおじちゃんたちにちゃんと届けてね！'],
      lost: ['ちょっと！ちゃんと持って行ってよ！'],
      complete1: [
        'あ、お姉ちゃん！',
        '絵を渡してきてくれたんだね！',
        'ありがとう！これ、お礼だよ！'
      ],
      complete2: ['じゃあね！'],
      completed: ['この前はありがとう！']
    },
    miner: {
      greet: ['あ？なんか用かい？'],
      options: ['絵を渡す', 'なんでもない'],
      log: '『頑張る炭坑夫』を渡した',
      solve: [
        'お屋敷のガキがお礼だって？',
        'ケッ、イイ御身分だぜ。',
        '絵なんて貰ったって俺たちの腹は膨れねえんだよ。',
        '…ん？',
        'お、この絵を収めてるフレームは中々高く売れそうだな。',
        'よしよし、久しぶりに腹いっぱい食えそうだ。',
        '姉ちゃん、ガキにまた描いてくれるよう頼んどいてくれよ。',
        'じゃあな。'
      ],
      regain: {
        options1: ['さっき前の絵、自分が買い取る', 'なんでもない'],
        start: [
          'あんたが買い取るって？',
          'まあいいだろう。',
          'じゃあ宝石を4種類集めてこい。',
          'それと交換だ。'
        ],
        options2: ['宝石4種を渡す', 'なんでもない'],
        logs: [
          'サファイヤを1個あげた',
          'エメラルドを1個あげた',
          'アメジストを1個あげた',
          'ルビーを1個あげた'
        ],
        complete: [
          'よし、持ってきたな。',
          'ありがとうよ。',
          'じゃあな。'
        ]
      }
    },
    lady1: {
      start: [
        '女の魅力は「美しさ」よ。',
        'そして、この世で一番美しいのは私。',
        'そう、隣の部屋の性悪女よりもね。',
        'でもね、私にも時が経てば老いが来るの。',
        'そうしたらやがて若い女たちに負けてしまうわ。',
        'そんなの御免よ。',
        '私は大金持ちなんだから、いつまでも一番であるべきだわ。',
        'そこで調べさせたの。',
        '外の森を抜けた先に病院があるのを知ってる？'
      ],
      started: [
        'その病院では、どうやら不老不死の薬が開発されていたらしいの。',
        '今も病院のどこかに隠されているという噂よ。',
        'だからあなた、それを探してきてちょうだい。',
        'お礼はたっぷりとあげるわ。'
      ],
      options: ['不老不死の薬を1個渡す', '渡さない'],
      log: '不老不死の薬を1個あげた',
      solve1: [
        'これが不老不死の薬ね！？',
        'さっそく使ってみるわ。',
        '………。'
      ],
      solve2: [
        '！！',
        'お肌のつやがいつにも増して良くなった気がするわ！',
        'この若さが永遠に続くのね！！',
        'あなた、よくやったわ！',
        'これはお礼よ！'
      ],
      solved: [
        'あなた、よくやったわ！',
        '私は永遠の一番よ！'
      ]
    },
    lady2: {
      greet: ['隣の部屋の勘違い女、気に入らないわ。'],
      start: [
        '隣の部屋の勘違い女、不老不死の薬とやらを手に入れたらしいの。',
        'あー、気に入らないわ。',
        'ねえ、あなた、',
        'あの女を殺してきてちょうだい。',
        '不老不死だなんて言ったって、',
        '鉄砲なんかで殺されてしまえばそれまででしょう？',
        '馬鹿な女ね。'
      ],
      started: [
        '何よその顔は？',
        'さっさと行きなさいよ。',
        '私は、あの女があなたにあげたお礼よりも、',
        'あなたがもっと欲しがっているものをお礼としてあげるわ。'
      ],
      complete1: [
        'よくやったわ。',
        'お礼をあげるわ。'
      ],
      complete2: [
        '永遠の若さだなんてナンセンスよ。',
        '私たちは有限だからこそ美しいのに。',
        'それに気付かないなんて哀れな女ね。'
      ],
      completed: ['うるさいのが消えてせいせいしたわ。']
    },
    forever: {
      ghost: {
        start: [
          'あなた、私が見えるんですね！？',
          'ああ、では是非お願いしたい事があります。',
          '私の話を聞いて頂けますでしょうか？'
        ],
        options: ['はい', 'いいえ'],
        answer1: [
          'よかった。',
          '私は見ての通り死んでいます。',
          '生きていた頃はこの病院に入院していました。',
          'そして私の主治医は、私の夫でもありました。',
          '夫はどんなに仕事で疲れていようと、毎晩ここで私の手を握ってくれていました。',
          '私の病は治せるものではなく、長く生きられない事を夫も私も分かっていました。',
          'ですが夫はいつだって「ずっとそばに居るよ」と私を励ましてくれていたんです。',
          'やがて病状は悪化し、いよいよ自分の死が目前に迫りました。',
          '覚悟を決めていたつもりでしたが、私はもう怖くてたまりませんでした。',
          '私の手を握る夫にこう聞きました。',
          '「…ずっと、…そばに居てくれますか？」と。',
          '夫は「約束するよ」と答えてくれました。',
          'それを聞くと私はとても安心したのです。',
          '私が死んだのはその晩のことでした。',
          'それから気付いた時には私はこの姿で病院を彷徨っていました。',
          '私は天国には行かなかったのです。',
          '夫が居なかったからです。',
          'ずっとそばに居ると約束したはずの夫が居ないんです。',
          '約束を忘れてしまったのでしょうか？',
          '私はここでずっと待っているというのに…。',
          'そこでお願いです。'
        ],
        answer2: ['………。'],
        started: [
          '夫を私の元へ連れて来て下さい。',
          '今でもこの病院で、この場所で働いているはずです。',
          'ですが、まだ生きています。',
          '生きていては私と一緒に天国へ行く事はできません。',
          'わかりますね？',
          'あなただけが頼りなんです。',
          'では、よろしくお願いします。'
        ],
        complete: [
          'あ！あなたは！',
          '夫をこちらへ連れて来てくれたんですね。',
          'これで私達はずっと一緒です。',
          '本当にありがとうございました。',
          'これはお礼です。'
        ],
        completed: [
          'これで私達はずっと一緒です。',
          '本当に、どうもありがとうございました。'
        ]
      },
      doctor: {
        greet: [
          '私は以前、この病室で妻を亡くしました…。',
          'でも今では私も前向きに頑張っています。'
        ],
        start1: [
          'え？',
          '私の妻の幽霊に会ったって？',
          '悪い冗談はやめてくださいよ。',
          '…え？',
          '私に妻の元へ行くように頼まれたって？',
          'ちょ、ちょっと待って下さい。',
          '私は、御覧の通りまだ生きているんですよ？',
          '………。',
          'か、勘弁して下さい。',
          '私はまだ死にたくありません。',
          '別の方と再婚をして長生きをしたいんです。'
        ],
        start2: ['…とにかく、そんなおっかない事は言わないでください。'],
        completed: [
          'どうして私を殺したんですか。',
          'あなたも、妻も、私の人生をなんだと思っているんですか。',
          'こんなのあんまりです。'
        ]
      }
    },
    raptor: {
      start: [
        'この前恐竜の映画を観たんだ。',
        'かなりよかったぜ。',
        'お前、本物の恐竜に会ってみたいって思うか？',
        '俺は思わないぜ。',
        '会っちまったらソイツはただの動物になっちまうだろ。',
        '残された化石からその姿を想像するしか無い、',
        'それがロマンってもんだろ？'
      ],
      advice: [
        'おい、お前化石をたくさん持ってるな。',
        'ひょっとして恐竜の化石なんじゃないか？',
        'ちょっと組み立ててみろよ。',
        '恐竜の化石だったら俺に譲ってくれ。'
      ],
      give: [
        'おい！それは恐竜の化石じゃないか！',
        '頼む！俺に譲ってくれ！'
      ],
      options: ['いいよ', 'いやだ'],
      cancel: [
        'そうか…、残念だ。'
      ],
      log: '恐竜の化石を渡した',
      gave: [
        'なんてこった！ついに恐竜の化石を手に入れちまったぜ！',
        'おい、これはお礼だ。',
        '感謝してるぜ。'
      ],
      completed: [
        'へへへ、ついに恐竜の化石を手に入れちまったぜ。'
      ]
    },
    brain: {
      message: 'アミリさんの頭の中は、アミリさんでいっぱいですね。',
      kajitsu1: [
        'どうです？ショックですか？',
        '人間というのはそういうものです。',
        '残念ながら、この世界に貴方の居場所はありません。'
      ],
      kajitsu2: [
        'これで決心はつきましたね？',
        '今の貴方ならこの世界を出ていくことが出来るでしょう。'
      ],
      kajitsu3: [
        '心臓の部屋で待っています。',
        '準備が出来たら来てください。'
      ],
      kajitsu4: [
        'ここから出て行き、アミリさんを解放してあげましょう。'
      ]
    },
    dream: {
      kajitsu1: ['来ましたね。'],
      kajitsu2: [
        'あなたはこれからこのアミリさんの心の中から出て、死後の世界へと旅立ちます。',
        'そうすれば、生死を彷徨っているアミリさんはじきに目覚めるでしょう。'
      ],
      kajitsu3: ['心の準備はいいですか？'],
      yesno: ['はい', 'いいえ'],
      cancel: ['では、準備が出来たらまた来てください。'],
      kajitsu4: ['では、ここから出ていきたいと強く願って下さい。'],
      message: 'よかった。目、覚ませそうだね。',
      amili1: [
        'リブラ、今まで騙していてごめん。',
        '今まで話した事、全部嘘なの…。'
      ],
      amili2: [
        'この世界は私の心の中なんかじゃない。',
        'この世界は…、',
        '貴方の心の中なの。'
      ],
      amili3: [
        '本当に死んだのは私で、生死を彷徨っているのは貴方。',
        '思い出せそう？'
      ],
      amili4: [
        'これは貴方の心臓。',
        '私は亡霊として貴方の心の中にいるの。',
        '貴方は、貴方自身の心に閉じこもっているせいで目覚められずにいた。',
        'だから、貴方がここから出る気になるように嘘をついたの。'
      ],
      amili5: [
        'リブラの頭の中、私のことでいっぱいだったね。',
        '…嬉しい。',
        'ふふ。私のことばっか考えてるから、目覚められなかったんだよ？'
      ],
      amili6: [
        'でも…、もう大丈夫だね。',
        '私の分までちゃんと生きて。'
      ],
      amili7: [
        '私はここで…、あなたの心の中で、ずっと待ってるから。',
        'さようなら。'
      ],
      options: ['今までありがとう', '出たくないと強く願う'],
      last1: {
        amili1: [
          '…リブラ。',
          '…またね。'
        ],
        message: 'しばらくの間、お別れだね。'
      },
      last2: {
        amili1: ['え、なに？'],
        amili2: ['！！'],
        amili3: ['…リブラ！'],
        amili4: ['…死んじゃったの？'],
        amili5: ['なんで…。'],
        amili6: [
          '…どうして？',
          'そこまでして、私と…？'
        ],
        message: 'これからは、ずっと一緒だね。'
      }
    },
    cosmos: {
      minePenguin1: [
        'おい、そこの地面を見てみろ。',
        '不思議な模様が描かれているだろ？',
        'あれにはきっと何か秘密があるに違いない。',
        '俺はその謎を解けなかったんだが、あんたも何か試しみるといい。'
      ],
      minePenguin2: [
        '宇宙に行っただって？',
        'そいつはすげえな。',
        'その話を信じられるかはともかく、',
        'こんなタコ部屋から宇宙に旅立てるなんて、夢のある話をありがとうな。'
      ],
      guide1: [
        'ワレワレハ、宇宙人ダ。',
        '宇宙ニ行キタイナラ、ソコノUFOニ乗ルンダ。'
      ],
      guide2: [
        '宇宙ニツイタゾ。',
        '人間ハ宇宙ニ来ルト、スグニ迷子ニナルカラナ。',
        'アマリ遠クヘハ行ケナイヨウニシテオイタゾ。',
        'デモ、本当ハモット広インダゾ。'
      ],
      evolution: [
        '君タチハ本当ニ自分ガネズミヤ猿カラ進化シタト思ッテイルノカイ？',
        '少シ考エレバソンナ訳ナイコトハ分カルハズダ。',
        '君タチハ別ノ星ノ生命体ニヨッテ作ラレタノダ。',
        '君タチハ奴隷トシテ作ラレ、反乱ヲ考エナイヨウニ、テロメア、ツマリ寿命ヲ100年ニ設定サレテイル。',
        '地球ノ他ノ生物ヲヨク見テミロ。',
        '成体ニナッテカラモ老ケテ姿ヲ変エルノハ君タチ人間ダケダ。',
        '言ッテオクガ、オ前タチヲ奴隷ニシタ宇宙人トハ、我々グレイ星人ノコトデハナイゾ。',
        'トコロデ、君タチ人間ハ東洋人ト西洋人デナゼ瞳ノ色ガ違ウカ知ッテイルカ？',
        '東洋人ハ霊長類ヲ、西洋人ハ爬虫類ヲ加工シテ作ラレタカラダ。',
        'ダカラ、君タチノ言ウ「猿カラ進化シタ」トイウノモアナガチ間違ッテハイナイノカモナ。'
      ]
    },
    photosynthesis: {
      greeting: [
        'ヤア、オ前ハ人間ダナ。',
        '我々グレイ星人ハ、人間ニトッテ最モ身近ナ宇宙人ダロウ。',
        '我々カラ見テモ人間ハ、最モ身近ナ研究対象ダ。',
        '我々カラ見テ人間ノ興味深イトコロハ、食事ト生殖ダ。',
        '我々ハ食事モ、有性生殖モ行ワナイカラサ。'
      ],
      questions: ['じゃあどうやって栄養を得るの？', 'じゃあどうやって子供つくるの？'],
      answer1: [
        '我々ハ光合成ヲスルノダ。',
        'オ前ニトッテ我々グレイ星人ハ何色ノイメージダ？',
        '緑色カ？灰色カ？',
        'ドチラモ正シイ。',
        '我々ハ普段ハ緑色デ、長ク光合成ヲシテイナイ時ニ灰色ニナル。',
        'ツマリ私ハ今、腹ガ減ッテイルトイウコトダ。'
      ],
      answer2: [
        'ソレハ秘密ダ。',
        '我々モ、オ前タチノ生殖ニツイテ研究シタイノダガ、何故ダカ誰モ協力シテクレナイノダ。'
      ],
      start: [
        'トコロデ、人間ヨ。',
        '我々ノ研究ニ協力シテホシイ。',
        '食事ニツイテ知リタイ。',
        '地球ノ料理ヲ持ッテキテクレ。',
        'オ前ノオススメヲ頼ム。'
      ],
      started: [
        'ヨシ、次ダ。',
        '地球ノ料理ヲモット持ッテキテクレ。'
      ],
      option: '#{name}を渡す',
      cancel: 'やめておく',
      log: '#{name}を渡した',
      omurice: [
        'コレハ、オムライストイウノカ。',
        '食ベテミルトシヨウ。',
        '…',
        'フムフム',
        'コノトロトロシタ黄色ト、上ニカカッテイル甘酸ッパイ赤イ液体ガウマイナ。',
        'マア、シカシ、光合成ノ方ガヨッポド美味シイゾ。'
      ],
      steak: [
        'コレハ、ステーキトイウノカ。',
        '食ベテミルトシヨウ。',
        '…',
        'フムフム',
        'ジューシーダナ。',
        'シカシ我々ノ顎デハ食ベルノガ大変ダ。',
        'ヤハリ、光合成ノ方ガヨッポド美味シイゾ。'
      ],
      curry: [
        'コレハ、カレートイウノカ。',
        '食ベテミルトシヨウ。',
        '…',
        'フムフム',
        '味ハイイナ。',
        'ン。',
        'コレハ口ノ中ガヒリヒリスルゾ。',
        'モウイラナイ。',
        'ヤハリ、光合成ノ方ガヨッポド美味シイゾ。'
      ],
      stirFry: [
        'コレハ、野菜炒メトイウノカ。',
        '食ベテミルトシヨウ。',
        '…',
        'フムフム',
        'シャキシャキトシタ食感ガイイナ。',
        'マア、シカシ、光合成ノ方ガヨッポド美味シイゾ。'
      ],
      complete: [
        'ヨシ、モウオ腹イッパイダ。',
        '協力ノオ礼ニ、コレヲヤロウ。',
        '地球カラ採取シタモノダ。'
      ],
      completed: [
        'オ前タチノ料理ヨリ、光合成ノ方ガヨッポド美味シイゾ。',
        'オ前タチモ光合成ヲスレバイイノニ。'
      ]
    },
    bogusDoctor: {
      talk1: [
        'あなたはこの病院の患者ではありませんね？',
        'ああ、でしたらどうか、私の長年の悩みを聞いてください。',
        'この話を誰にも言わないと約束していただけますか？'
      ],
      options1: ['はい', 'いいえ'],
      cancel: ['そうですか。'],
      talk2: [
        'よかった。',
        '実はこの病院、昔は医者が1人も居なかったんです。',
        'ただ患者だけが居ました。',
        'だから当然、患者たちは何の処置もされずに亡くなっていきました。',
        '私は医者でも何でもなかったのですが、それを見てはいられなかったのです。',
        '病院にあった医学書を読みながら、半ば当てずっぽうで薬を処方しました。',
        'うまくいったこともあれば、私の間違いで悪化させてしまったこともありました。',
        'いつしか患者たちは、私を医者だと思うようになりました。',
        'やがて薬だけではどうにもできず、手術をしなければいけなくなりました。',
        'いくら本を読んだって、上手に手術ができるわけがありません。',
        '当然、何度も失敗しました。',
        'いえ、何度も患者を殺してしまいました。',
        'それでも患者たちは、たった1人の偽物の医者を頼るしかありませんでした。',
        'それから手術の腕は上達し、患者の命を救えるようになりました。',
        'ですが、昔私の手術で死んでいった患者たちのことが頭から離れないのです。',
        '彼らのうめき苦しむ顔が、声が、いつでも頭の中から離れないのです。',
        '私は葛藤してきました。'
      ],
      talk3: [
        'もし彼らの何十倍、何百倍もの命を救えば、彼らも浮かばれるのではないか？',
        '私は許されるのではないか？',
        'そう思って、毎日必死で患者たちを救ってきました。',
        'ですが、今でも分からないのです。',
        '私は許されたのでしょうか？'
      ],
      options2: ['あなたは偉大な医者だ', '彼らはあなたを恨んでいる'],
      answer1: [
        'そんなふうに言っていただけるなんて。',
        'ああ、少し肩の荷が下りた気分です。'
      ],
      answer2: [
        'そうですよね。',
        '自分の犠牲の上にたくさんの人が助かろうと、本人からすればとんでもない。',
        'この罪滅ぼしは私の自己満足です。',
        'あらためて、決心がつきました。',
        '私は一生をかけてこの罪滅ぼしを続けていきます。'
      ],
      complete: [
        '話を聞いてくれて感謝しています。',
        'お礼にこれを。'
      ],
      completed: [
        'さて、こうしてはいられません。',
        '患者たちが待っていますから。'
      ],
      patient0: [
        '先生、こっちだ。',
        'こっちに来てくれ。'
      ],
      patient1: [
        '先生、医者だなんて、嘘だったんですね。',
        '…酷いです。',
        '私の体、こんなに傷だらけになってしまって…。'
      ],
      patient2: [
        '寒い。寒いよ。',
        '先生、どうして体がこんなに寒いんですか？',
        '先生…、助けて。'
      ],
      patient3: [
        '痛い！！',
        '痛いよ先生！！',
        'こんなに痛いの、もう、耐えられないよ！！',
        'なんとかしてよ！！'
      ],
      patient4: [
        '先生、手術したら助かるって嘘だったのかよ。',
        'どうなってるんだよ、これ。',
        '俺、死んでるじゃねえかよ…。なあ。'
      ],
      patient5: [
        '先生、あなたが本当のお医者さんじゃなくても、私は感謝しています。',
        'あなたは私の命を救うために、必死に頑張ってくれました。',
        '恨んでなんかいません。',
        'さあ、部屋の明かりをつけて。',
        'いつまでも心優しい先生でいてくださいね。'
      ],
      lockMap: '逃げられないよ' // There is no escape
    }
  },
  happyend: {
    title: 'ハッピーエンド',
    lyrics: [
      '夜風の音が 神さまの声なら',
      '聞きに行くのさ 日が昇るまで',
      'そして優しい 心を手に入れて',
      '誰かのために 生きてみるのさ',
      '僕の死ぬ日が 世界の終わりなら',
      '悲しむ人は 居るわけなくて',
      '明日その日が 訪れたとしても',
      '光がひとつ 輝くだけさ',
      '日が落ちるころ 聴いていた歌',
      '綺麗事流れ続けた',
      'あなたが降らす雨が涙でも',
      '僕の心には虹がかかるなら',
      'ご機嫌な曲で終わるハッピーエンド',
      'そんな毎日も幸せなのさ',
      'いつか愛した あの子が泣いていた',
      '僕は悲しいフリをしたのさ',
      '大好きな歌詞 大好きな音',
      '嘘つきも優しく見えた',
      'あなたが降らす雨が涙でも',
      '僕の心には虹がかかるなら',
      'ご機嫌な曲で終わるハッピーエンド',
      'そんな毎日も幸せなのさ',
      '明日の朝が世界の終わりでも',
      'そんな悲しい顔しないでよ'
    ]
  }
}
